<template>
  <div class="pg-image-point">
    <div class="pg-image-point__box">
      <img v-if="!!src" ref="imgRef" :src="src" />
      <pointItem
        v-for="(item, index) in points"
        :key="index"
        :point="item"
        :drag="drag"
        :popperClass="popperClass"
        @on-xy="(xy) => onXy(item, xy)"
        :imgXy="imgXy"
      >
        <slot :point="item"></slot>
      </pointItem>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, watch } from 'vue'
import pointItem from './point-item.vue'

const emit = defineEmits(['input'])
const props = defineProps({
  value: Array,
  src: String,
  drag: Boolean,
  popperClass: String,
})

const imgPrimitiveWidth = ref(0)
watch(
  () => props.src,
  () => {
    if (!props.src) {
      imgPrimitiveWidth.value = 0
    } else {
      const imageInstance = new Image()
      imageInstance.onload = () => {
        imgPrimitiveWidth.value = imageInstance.width
      }
      imageInstance.onerror = () => {
        imgPrimitiveWidth.value = 0
      }
      imageInstance.src = props.src
    }
  },
  { immediate: true }
)

const imgRef = ref(null)
const imgXy = () => {
  return {
    width: imgRef.value.clientWidth,
    height: imgRef.value.clientHeight,
  }
}
const points = computed(() => {
  if (imgPrimitiveWidth.value == 0 || !props.value?.length || !imgRef.value) {
    return []
  } else {
    const scale = imgPrimitiveWidth.value / imgRef.value.clientWidth
    return props.value.map((im) => {
      if (im.x === 'center' && im.y === 'center') {
        im.x = (imgRef.value.clientWidth / 2) * scale
        im.y = (imgRef.value.clientHeight / 2) * scale
      }
      const { x, y, ...other } = im
      return {
        x: x / scale,
        y: y / scale,
        ...other,
      }
    })
  }
})

const onXy = (item, xy) => {
  item.x = xy.x
  item.y = xy.y
  const nowPoint = props.value.find((im) => im.location?.id === item.location?.id)
  const scale = imgPrimitiveWidth.value / imgRef.value.clientWidth
  nowPoint.x = scale * xy.x
  nowPoint.y = scale * xy.y
  emit('input', props.value)
}
</script>
<style lang="scss">
@import '../style/image-point.scss';
</style>
